import React, { useState, useEffect, useCallback } from 'react';
import BrainLogo from './BrainLogo';
import DarkModeToggle, { useDarkMode } from './DarkModeToggle';
import { NAV_LINKS } from '../data/siteData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dark, setDark] = useDarkMode();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 28);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = useCallback((e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
    }
    setMobileOpen(false);
  }, []);

  return (
    <>
      <nav id="nav" className={scrolled ? 'scrolled' : ''} aria-label="Main navigation">
        {/* Logo */}
        <a
          href="#home"
          className="logo"
          onClick={(e) => handleNavClick(e, '#home')}
          aria-label="JSDevBrains — go to home"
        >
          <div className="logo-mark">
            <BrainLogo id="nav" size={46} />
          </div>
          <div className="logo-text">
            JSDevBrains<span className="dot">.</span>
            <span className="sub">Digital Pvt Ltd</span>
          </div>
        </a>

        {/* Desktop links */}
        <ul className="nav-links">
          {NAV_LINKS.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Right actions */}
        <div className="nav-r">
          <DarkModeToggle dark={dark} setDark={setDark} />
          <a
            href="https://wa.me/918123629993"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-ghost"
            style={{ fontSize: '.77rem', padding: '.38rem .9rem' }}
            aria-label="Chat on WhatsApp"
          >
            💬 WhatsApp
          </a>
          <a
            href="#contact"
            className="btn btn-green"
            id="navCta"
            onClick={(e) => handleNavClick(e, '#contact')}
            style={{ fontSize: '.77rem', padding: '.38rem 1rem', display: scrolled ? 'inline-flex' : 'none' }}
          >
            Get Started
          </a>
          <button
            className="ham"
            id="ham"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="Toggle menu"
            aria-expanded={mobileOpen}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      <div className={`mob${mobileOpen ? ' open' : ''}`} id="mobMenu" role="navigation" aria-label="Mobile navigation">
        {NAV_LINKS.map((link) => (
          <a key={link.href} href={link.href} onClick={(e) => handleNavClick(e, link.href)}>
            {link.label}
          </a>
        ))}
        <a
          href="https://wa.me/918123629993"
          target="_blank"
          rel="noopener noreferrer"
          className="mob-wa"
          onClick={() => setMobileOpen(false)}
        >
          💬 Chat on WhatsApp
        </a>
      </div>
    </>
  );
}
